// Dialog popup para mostrar la configuración de un chart sin navegar a otra ruta.
// Embebe el componente *Config con `embedded` y `sectorIdOverride`/`farmIdOverride`.

import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { CHART_COLORS } from '../chartColors';

interface ChartConfigDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

const ChartConfigDialog: React.FC<ChartConfigDialogProps> = ({
  open,
  onClose,
  title,
  children,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="lg"
    fullWidth
    PaperProps={{
      sx: {
        borderRadius: 3,
        maxHeight: '90vh',
      },
    }}
  >
    <DialogTitle
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: `1px solid ${CHART_COLORS.border}`,
        py: 1.5,
        px: 2.5,
        fontSize: '1.05rem',
        fontWeight: 600,
        color: CHART_COLORS.textPrimary,
      }}
    >
      {title}
      <IconButton
        aria-label="cerrar"
        onClick={onClose}
        size="small"
        sx={{
          color: CHART_COLORS.textMuted,
          '&:hover': { color: CHART_COLORS.textPrimary, background: CHART_COLORS.overlay },
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </DialogTitle>
    <DialogContent sx={{ p: 2, overflow: 'auto' }}>{children}</DialogContent>
  </Dialog>
);

export default ChartConfigDialog;
